import { isLocalhost } from './is-localhost';

type SharingLinkLike =
  | {
      sharingUrl?: string | null;
      token?: string | null;
    }
  | null
  | undefined;

/**
 * Builds the viewer link from the sharingLink returned by the backend.
 *
 * When the app is running on localhost, or when the customer does not have
 * the `CustomDomains` feature enabled, the absolute `sharingUrl` (which
 * points at the production/QA viewer host) is reduced to its path + search
 * so navigation stays on the current origin.
 */
export function buildViewerLink(sharingLink: SharingLinkLike, customDomainsEnabled?: boolean): string {
  const url = sharingLink?.sharingUrl;
  if (!url) return '';

  const useRelativePath = isLocalhost() || !customDomainsEnabled;
  const resolvedUrl = useRelativePath ? toRelativePath(url) : url;
  if (!sharingLink?.token) return resolvedUrl;

  const separator = resolvedUrl.includes('?') ? '&' : '?';
  return `${resolvedUrl}${separator}hmac-token=${sharingLink.token}`;
}

function toRelativePath(url: string): string {
  try {
    const parsed = new URL(url);
    // Collapse any leading run of slashes to a single `/` so the result
    // can never be interpreted as a protocol-relative URL (`//host/path`).
    const safePathname = parsed.pathname.replace(/^\/+/, '/');
    return `${safePathname}${parsed.search}`;
  } catch {
    // Already relative (or otherwise unparseable) — return as-is.
    return url;
  }
}
